import React from "react"
import PropTypes from "prop-types"
import { classNames } from "@commonUtils"

import css from "./PrimaryButton.scss"

const BTN_THEME = {
    coral: "coral",
    white: "white",
    black: "black",
    coralOutlined: "coralOutlined",
    danger: "danger",
    coralGradient: "coralGradient",
    coralGradientBright: "coralGradientBright",
    oceanGradient: "oceanGradient",
}

function PrimaryButton({
    isDisabled = false,
    iconUrl,
    rightIconUrl,
    onClick,
    label = "Button",
    theme = BTN_THEME.coral,
    elevate = false,
    fitContent = false,
    loading = false,
    showAnimation,
    labelClass = "",
    as = "button",
}) {
    const ICON_SIZE = 20
    const btnStyles = classNames(css.buttonContainer, css[BTN_THEME[theme]], {
        [css.fitContent]: fitContent,
        [css.elevatedBorder]: elevate && theme === "coralOutlined",
        shadow: elevate && theme !== "coralOutlined",
    })
    const labelStyles = classNames("bodyMediumBold", css.btnText, labelClass, { "mLeft-4": iconUrl })
    const loaderStyles = classNames(css.spinner, { [css.light]: ["coral", "black"].includes(theme) })
    const Tag = as
    return (
        <div className={css.buttonWrapper}>
            <Tag className={btnStyles} onClick={onClick} disabled={isDisabled} data-testid="primary-button">
                {loading ? (
                    <div className={loaderStyles} />
                ) : (
                    <>
                        {iconUrl && <img src={iconUrl} alt="" width={ICON_SIZE} height={ICON_SIZE} />}
                        <span className={labelStyles}>{label}</span>
                        {rightIconUrl && (
                            <img
                                className="mLeft-4"
                                src={rightIconUrl}
                                alt=""
                                width={ICON_SIZE}
                                height={ICON_SIZE}
                            />
                        )}
                    </>
                )}
            </Tag>
            {showAnimation && (
                <>
                    <div className={css.blendedLine}></div>
                    <div className={css.blendedLine}></div>
                </>
            )}
        </div>
    )
}

PrimaryButton.propTypes = {
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    iconUrl: PropTypes.string,
    rightIconUrl: PropTypes.string,
    label: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(["coral", "black", "white", "coralOutlined", "coralGradient"]),
    elevate: PropTypes.bool,
    fitContent: PropTypes.bool,
    loading: PropTypes.bool,
    showAnimation: PropTypes.bool,
    labelClass: PropTypes.string,
    as: PropTypes.string,
}

export default PrimaryButton
